// ViewPayroll.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_URL } from "../url";
import "../Styling/viewPayroll.css"; // keep your CSS import
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ConfirmModal({
  isOpen,
  title = "Confirm",
  message = "Are you sure?",
  confirmLabel = "Yes confirm",
  cancelLabel = "No",
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-overlay" role="dialog" aria-modal="true">
      <div className="confirm-modal">
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>

        <div className="confirm-modal-actions">
          <button
            className="confirm-btn cancel"
            onClick={onCancel}
            type="button"
            disabled={loading}
          >
            {cancelLabel}
          </button>

          <button
            className="confirm-btn confirm"
            onClick={onConfirm}
            type="button"
            disabled={loading}
          >
            {loading ? "Processing..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ViewPayrollNew() {
  const [transferModes, setTransferModes] = useState({});

  const { id } = useParams();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [orgId, setOrgId] = useState("");
  const [compCode, setCompCode] = useState("");
  const [yearVal, setYearVal] = useState("");
  const [monthName, setMonthName] = useState("");

  // modal & posting states
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [posting, setPosting] = useState(false);

  const monthMap = {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December",
  };

  useEffect(() => {
    if (!id) return;

    const organisationId = id.substring(0, 4);
    const companyCode = id.substring(4, 8);
    const year = id.substring(8, 12);
    const month = id.substring(12, 14);

    // Save values into state
    setOrgId(organisationId);
    setCompCode(companyCode);
    setYearVal(year);
    setMonthName(monthMap[month] || "Invalid");

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const resp = await axios.get(
          `${Base_URL}/SalaryProcess/GetPayrollData/id?id=${id}`
        );
        setRows(resp.data || []);
        const initialModes = {};
(resp.data || []).forEach((item) => {
  const resourceId = item.payroll?.resourceid;
  if (resourceId) {
    initialModes[resourceId] = "Bank"; // default
  }
});
setTransferModes(initialModes);

      } catch (err) {
        console.error("Failed to fetch payroll data:", err);
        setError(err.response?.data || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);
  const handleTransferModeChange = (resourceId, value) => {
  setTransferModes((prev) => ({
    ...prev,
    [resourceId]: value,
  }));
};

  const toNum = (v) => {
    if (v === null || v === undefined) return 0;
    const n = Number(String(v).replace(/,/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

 const summary = rows.reduce(
    (acc, item) => {
      const p = item.payroll || {};
      const s = item.salary || {};

      acc.sumNetPayable += toNum(p.net)||toNum(p.proRatedSalary);
      acc.sumBase += toNum(p.baseInHand);
      acc.sumHra += toNum(p.hra);
      acc.sumOther += toNum(p.otherAllowance);
      acc.sumDeductions += toNum(p.totalDeductions);
      acc.sumCalcBasic += toNum(p.basicPlusDa); // ✅ FIX ADDED

      acc.sumOrigBasic += toNum(s.basicPlusDa);
      acc.sumOrigHra += toNum(s.hra);
      acc.sumOrigSpl += toNum(s.splAll ?? s.other);

      acc.sumGross += toNum(p.baseInHand) 
  acc.sumMa+=toNum(s.ma)
      acc.sumTa+=toNum(s.ta)
      acc.sumCalMA+=toNum(p.ma)
      acc.sumCalTA+=toNum(p.ta)
      acc.gross+=toNum(p.gross)
      return acc;
    },
    {
      sumNetPayable: 0,
      sumBase: 0,
      sumHra: 0,
      sumOther: 0,
      sumDeductions: 0,
      sumGross: 0,

      sumCalcBasic: 0, // ✅ INITIALIZE
      sumOrigBasic: 0,
      sumOrigHra: 0,
      sumOrigSpl: 0,
      sumTa:0,
      sumMa:0,
      sumCalTA:0,
      sumCalMA:0,
      gross:0
    }
  );

  const fmtCurrency = (n) =>
    new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);

  // Build payload & post
 const handleSendNetPayables = async () => {
  setPosting(true);
  try {
    const items = rows
      .filter((item) => {
        const rid = item.payroll?.resourceid;
        return transferModes[rid] === "Bank"; // ✅ ONLY BANK
      })
      .map((item) => {
        const p = item.payroll || {};
        return {
          resourceId: p.resourceid,
          payrollId: p.payrollId ?? null,
          netPayable: toNum(p.net),
          transferMode: "Bank", // optional, useful for backend
        };
      });

    if (items.length === 0) {
      toast.error("No employees selected for bank transfer");
      setPosting(false);
      return;
    }

    const payload = {
      runId: id,
      items,
    };

    console.log("Final Payroll Payload:", payload);

    const res = await axios.post(
      `${Base_URL}/SalaryProcess/PostPayroll`,
      payload
    );

    toast.success("Payroll executed successfully");
    setShowConfirmModal(false);
    navigate("/hr-dashboard");
  } catch (err) {
    console.error("Error posting payroll:", err);
    toast.error(err.response?.data || err.message);
  } finally {
    setPosting(false);
  }
};


  // Confirm button handler: call the sender
  const onConfirmExecute = async () => {
    await handleSendNetPayables();
  };

  if (loading) {
    return (
      <div>
        <h2>View Payroll</h2>
        <p>Loading payroll data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h2>View Payroll</h2>
        <div style={{ color: "red" }}>Error: {String(error)}</div>
      </div>
    );
  }
 const handleDownloadExcel = () => {
  if (!rows || rows.length === 0) {
    toast.error("No payroll data to download");
    return;
  }

  let totals = {
    "Actual Basic + DA": 0,
    "Actual HRA": 0,
    "Actual Special Allowance": 0,
    "Actual MA": 0,
    "Actual TA": 0,
    "Actual Gross": 0,
    "Actual PF": 0,
    "Actual ESIC": 0,

    "Earning Basic + DA": 0,
    "Earning HRA": 0,
    "Earning MA": 0,
    "Earning TA": 0,
    "Earning Special Allowance": 0,
    "Earning Gross": 0,

    "PF Deduction": 0,
    "ESIC Deduction": 0,
    "Total Deductions": 0,
    "Net Payable": 0,
  };

  const excelData = rows.map((item) => {
    const p = item.payroll || {};
    const s = item.salary || {};
    const origSpl = s.splAll ?? s.other ?? 0;

    const row = {
      Resource: item.resource,
      "Resource ID": p.resourceid,

      "Actual Basic + DA": toNum(s.basicPlusDa),
      "Actual HRA": toNum(s.hra),
      "Actual Special Allowance": toNum(origSpl),
      "Actual MA": toNum(s.ma),
      "Actual TA": toNum(s.ta),
      "Actual Gross": toNum(p.baseInHand) || toNum(p.proRatedSalary),
      "Actual PF": toNum(s.pfEmployee),
      "Actual ESIC": toNum(s.esicEmployee),

      "Calendar Days": p.calendarDays,
      "Present Days": p.salaryDays,

      "Earning Basic + DA": toNum(p.basicPlusDa),
      "Earning HRA": toNum(p.hra),
      "Earning MA": toNum(p.ma),
      "Earning TA": toNum(p.ta),
      "Earning Special Allowance": toNum(p.otherAllowance),
      "Earning Gross": toNum(p.proRatedSalary),

      "PF Deduction": toNum(p.pf12Percent),
      "ESIC Deduction": toNum(p.esic075Percent),
      "Total Deductions": toNum(p.totalDeductions),

      "Net Payable": toNum(p.net) || toNum(p.proRatedSalary),
      "Transfer Mode": transferModes[p.resourceid] || "Bank",

    };

    // ➕ accumulate totals
    Object.keys(totals).forEach((key) => {
      totals[key] += toNum(row[key]);
    });

    return row;
  });

  // ➕ Totals Row
  const totalsRow = {
    Resource: "TOTAL",
    "Resource ID": "",
    ...totals,
  };

  excelData.push(totalsRow);

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    blob,
    `Payroll_${orgId}_${compCode}_${monthName}_${yearVal}.xlsx`
  );
};


  return (
    <div className=" payroll-container">
      {/* Heading */}
      <h2 className="text-2xl font-semibold">Payroll For</h2>
      <div className="mb-4 text-gray-700">
        <p>
          <b>Organisation ID:</b> {orgId}
        </p>
        <p>
          <b>Company Code:</b> {compCode}
        </p>
        <p>
          <b>Year:</b> {yearVal}
        </p>
        <p>
          <b>Month:</b> {monthName}
        </p>
      </div>

     <div className="flex items-center justify-between mb-4 gap-3">
  <button
    onClick={() => setShowConfirmModal(true)}
    disabled={loading || rows.length === 0}
    className={`px-4 py-2 rounded shadow ${
      loading || rows.length === 0
        ? "opacity-50 cursor-not-allowed"
        : "hover:opacity-90"
    }`}
  >
    Execute Payroll
  </button>

  <button
    onClick={handleDownloadExcel}
    disabled={rows.length === 0}
    className={`px-4 py-2 rounded shadow bg-green-600  ${
      rows.length === 0
        ? "opacity-50 cursor-not-allowed"
        : "hover:bg-green-700"
    }`}
  >
    Download Excel
  </button>
</div>


      {/* Summary (card boxes) - uses external CSS */}
      <div className="summary-container">
        <div className="summary-card">
          <div className="summary-label">Total Net Payable</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumNetPayable)}</div>
        </div>

        {/* Now shows Total Gross (from payroll.gross or fallback) */}
        <div className="summary-card">
          <div className="summary-label">Total Gross</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumGross)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total HRA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Special Allowance</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOther)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Total Deductions</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumDeductions)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig Basic + DA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigBasic)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig HRA</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigHra)}</div>
        </div>

        <div className="summary-card">
          <div className="summary-label">Orig Special Allow.</div>
          <div className="summary-value">₹ {fmtCurrency(summary.sumOrigSpl)}</div>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="min-w-full divide-y">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Resource</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Resource ID</th>

              {/* ORIGINAL SALARY */}
            <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual Basic + DA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual HRA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual Special Allow.</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual MA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual TA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual Gross</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual PF</th>
                <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Actual ESIC</th>

              {/* CALCULATED PAYROLL AFTER */}
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Calendar Days</th>
               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Present Days</th>

               <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning Basic + DA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning HRA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning MA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning TA</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning Special Allowance</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Earning Gross</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Pf Deduction</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Esic Deduction</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Total Deductions</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">Net Payable</th>
              <th className="px-3 py-3 text-left text-sm font-medium text-gray-700">
  Bank Transfer
</th>

            </tr>
          </thead>

          <tbody className="divide-y">
            {rows.map((item, idx) => {
              const p = item.payroll || {};
              const s = item.salary || {};
              const origSpl = s.splAll ?? s.other ?? 0;

              return (
                <tr key={p.payrollId ?? idx}>
                  <td className="px-2 py-2 text-sm">{item.resource}</td>
                  <td className="px-2 py-2 text-sm">{p.resourceid}</td>

                  {/* ORIGINAL SALARY */}
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.hra))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(origSpl))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.ta))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.basicPlusDa+s.hra+s.ma+s.ta+origSpl))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.pfEmployee))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(s.esicEmployee))}</td>
                
                  {/* CALCULATED */}
                 <td className="px-2 py-2 text-sm">{p.calendarDays ?? "-"}</td>
                  <td className="px-2 py-2 text-sm">{p.salaryDays ?? "-"}</td>

                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.basicPlusDa))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.hra))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.ma))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.ta))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.otherAllowance))}</td>
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.proRatedSalary))}</td>
               <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.pf12Percent))}</td>
               <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.esic075Percent))}</td>
                  <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.totalDeductions))}</td>
                   <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(toNum(p.net) || toNum(p.proRatedSalary) )}</td>
                   <td className="px-3 py-3 text-sm">
  <select
    value={transferModes[p.resourceid] || "Bank"}
    onChange={(e) =>
      handleTransferModeChange(p.resourceid, e.target.value)
    }
    className="border rounded px-2 py-1"
  >
    <option value="Bank">Bank</option>
    <option value="Hold">Hold</option>
  </select>
</td>

                </tr>
              );
            })}
          </tbody>

          <tfoot className="bg-gray-50">
            <tr>
              <td className="px-2 py-2 text-sm font-medium">Totals</td>
              <td />

              {/* Original */}
       <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigBasic)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigHra)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOrigSpl)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumMa)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumTa)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.gross)}</td>

              <td />
              <td />
              <td/>
              <td/>
              {/* Calculated */}
           <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalcBasic)}</td> {/* ✅ FIX */}
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumHra)}</td>
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalMA)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumCalTA)}</td>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumOther)}</td>
           <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumGross)}</td>
            <td/>
            <td/>
              <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumDeductions)}</td>
              
                <td className="px-3 py-3 text-sm text-left">₹ {fmtCurrency(summary.sumNetPayable)||fmtCurrency(summary.sumGross)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        isOpen={showConfirmModal}
        title="Post Payroll"
        message="Are you sure you want to post?"
        confirmLabel="Yes confirm"
        cancelLabel="No"
        onCancel={() => setShowConfirmModal(false)}
        onConfirm={onConfirmExecute}
        loading={posting}
      />
    </div>
  );
}
